import React, { useState, useEffect, useCallback } from 'react';
import PropTypes from 'prop-types';

// Styles
import './style.scss';

const TableTasksCell = ({ tasks }) => {
  const [currentTasks, setCurrentTasks] = useState([]);

  useEffect(() => {
    setCurrentTasks(tasks);
  }, [tasks]);

  return (
    <div className="TableTasksCell">
    {currentTasks.map(task => (
      <div className="TableTaskCell" key={task.id}>
        <div>{task.name}</div>
      </div>
    ))}
  </div>
  );
}

TableTasksCell.propTypes = {
  tasks: PropTypes.array.isRequired,
}

export default TableTasksCell;